<script setup lang="ts">
  import { Badge } from '@gat-ship/vue-components'
  import { useFormatting } from '@gat-ship/utils'
  import { type TenantUser } from '@gat-ship/types'
  import {
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipContent
  } from '@gat-ship/vue-components'
  import { useTenantUserUtils } from '../../composables/useTenantUserUtils'
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  import { IconCalendarClock } from '@gat-ship/icons'
  const { formatDateTime } = useFormatting()
  const { TenantUserUtils } = useTenantUserUtils()
  const props = defineProps<{
    tenantUser?: TenantUser
    class?: HTMLAttributes['class']
  }>()
</script>

<template>
  <TooltipProvider
    v-if="
      props.tenantUser &&
      TenantUserUtils.isScheduledForDeactivation(props.tenantUser)
    "
  >
    <tooltip>
      <TooltipTrigger as-child>
        <badge
          :class="
            cn(
              'group-hover:bg-border flex w-fit items-center gap-1 p-1 px-2 text-xs',
              props.class
            )
          "
          variant="secondary"
          @click.stop
        >
          <icon-calendar-clock class="size-3.5" />
          Scheduled For Deactivation
        </badge>
      </TooltipTrigger>
      <TooltipContent>
        Will be deactivated on
        {{ formatDateTime(props.tenantUser?.activeTo) }}
      </TooltipContent>
    </tooltip>
  </TooltipProvider>
</template>
